module.exports = __webpack_public_path__ + "static/media/student-score-hall.54abece4.png";